import { motion } from "framer-motion";

export default function SectionHeading({ number, title, kicker, dark = false }) {
  return (
    <div className="mb-14 sm:mb-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <span className={`overline ${dark ? "text-white/50" : "text-[color:var(--muted)]"}`}>
          {number} — {kicker}
        </span>
        <h2 className={`font-display mt-5 text-4xl sm:text-5xl lg:text-6xl tracking-tight ${dark ? "text-white" : "text-ink"}`}>
          {title}
        </h2>
      </motion.div>
    </div>
  );
}
